import React from "react";
import { Box, Typography, Card, CardContent, Grid, } from "@mui/material";
import Data from "../pages/Data/Activitie.json";
import ActivitieCard from "./Card/ActivitieCard";
import Container from '@mui/material/Container';
const MoreActivities = ({ image, title, description }) => {

    const currentSubject = Data?.more_future || []; // Ensure `currentSubject` is safely accessed

    return (

        <Container maxWidth="lg">
            <Box sx={{ p: 4, textAlign: "center" }}>
                <Typography
                    variant="h3"
                    sx={{ fontWeight: "bold", padding: "80px", color: "#1976d2" }}
                >
                    More Features
                </Typography>
                <Grid spacing={4} justifyContent="center">
                    {currentSubject.map((subject, index) => (
                        <Grid item size={{ xs: 12, md: 6, lg: 4 }}  key={index}>
                            <ActivitieCard
                                image={subject.image}
                                title={subject.title}
                                description={subject.description}
                                index={index}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>

    );
};

export default MoreActivities;
